export default {
  goBackProfile: 'Профиль',
  goBackPaymentMethod: 'Форма оплаты',
  paymentMethod: {
    navText: 'Выбор формы \nоплаты',
    title: 'Выберите форму оплаты',
    annotation: 'Выберите, как будете оформлять квартиру'
  },
  paymentBenefits: {
    title: 'Информация об оплате',
    navText: 'Данные для оплаты',
    noBenefits: 'Без льгот',
    confirm: 'Подтвердить',
    photoLoaded: 'Фотография загружена',
    maternal_capital_certificate: 'Сертификат о материнском капитале',
    maternal_capital_certificate_balance: 'Справка об остатке на текущий день',
    mortgage_certificate: 'Ипотечное свидетельство',
    subsidy_certificate: 'Сертификат субсидии',
    chooseBank: 'Выберите банк'
  },
  confirmationModal: {
    methodTitle: 'Вы уверены, что хотите изменить форму оплаты?',
    methodDescription: 'Все загруженные Вами ранее документы будут удалены.',
    benefitTitle: 'Вы уверены, что хотите изменить льготу?',
    benefitDescription: 'Все загруженные Вами ранее документы будут удалены.'
  },
  installmentCalculator: {
    title: 'Выберите условия рассрочки',
    annotation: 'Минимум два месяца до сдачи объекта.\n Первоначальный взнос от 50% стоимости квартиры',
    initialPayment: 'Первоначальный взнос',
    termOfPayment: 'Срок платежей',
    month: '{count} месяца',
    expiryDate: 'Закроете рассрочку',
    dates: {
      0: 'В январе {year}',
      1: 'В феврале {year}',
      2: 'В марте {year}',
      3: 'В апреле {year}',
      4: 'В мае {year}',
      5: 'В июне {year}',
      6: 'В июле {year}',
      7: 'В августе {year}',
      8: 'В сентябре {year}',
      9: 'В октябре {year}',
      10: 'В ноябре {year}',
      11: 'В декабре {year}'
    },
    monthlyPayment: 'Ежемесячный платеж',
    priceValue: '{price} ₽'
  },
  errorSendingDocs: 'При загрузке документов произошла ошибка'
}
